import { useState } from "react"
import type { SelectOptionType } from "types"
import { APPROVAL_DROPDOWN_DATA } from "../enum"

export const useGetDropdownApproval = () => {
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(true)

  setTimeout(() => {
    setData(APPROVAL_DROPDOWN_DATA)
    setLoading(false)
  }, 1000);

  return { data, isLoading }
}